export default (...classes) => classes.filter(Boolean).join(' ')